/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import {
  CenterError as Error,
  ClearIcon as Clear,
} from "../../ui-components/uim-components";
import { Card, CardContent, IconButton, Tooltip as MTooltip, CircularProgress } from "@mineral/core";
import Resource from "./Resource";
import {
  fetchActiveDevicespoll,
  pollActiveDevicesStop,
} from "./../../../api/home-screen/actions";
import connect from "./../../../utils/connect";
//Monitored Devices
const title = Resource.get("Monitored Devices");
const Panel = (props) => {
  const monitoredDevices = props.monitoredDevices;
  //Last 30 minutes
  let minuteText = Resource.get("Last 30 minutes");

  return (
    <CardContent
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f4f4",
        padding: "0px",
        flex: "90%",
      }}
    >
      <span role="text" aria-label={monitoredDevices + " " + title} className="monitored__devices--count">{monitoredDevices}</span>
      <label aria-label={minuteText} className="monitored__devices--label">{minuteText}</label>
    </CardContent>
  );
};

class PanelContainer extends Component {
  state = {
    status: "loading",
    discoveredDevices: 0,
    monitoredDevices: 0,
  };
  apiError = () => {
    this.setState({
      status: "failure",
    });
  };

  componentDidMount() {
    this.props.fetchActiveDevicespoll();
  }
  componentWillUnmount() {
    this.props.pollActiveDevicesStop();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      discoveredDevices:
        nextProps.data.length > 0
          ? nextProps.data[0].totalDiscoveredDeviceCount
          : 0,
      monitoredDevices:
        nextProps.data.length > 0
          ? nextProps.data[0].activelyMonitoredDeviceCount
          : 0,
      status: "complete",
    });
  }
  render() {
    let view = (
      <Panel
        className={this.props.className}
        monitoredDevices={this.state.monitoredDevices}
      />
    );


    //Discovered
    let discoveredText = Resource.get("Discovered");
    let cardHeader = (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flex: "10%",
        }}
      >
        <h2 className="overview_container_title">{title}</h2>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ margin: "0px 10px", fontSize: "14px" }} aria-label={discoveredText}>
            {discoveredText}
          </span>
          <span style={{ fontSize: "14px", fontWeight: "bold" }} aria-label={this.state.discoveredDevices}>
            {this.state.discoveredDevices}
          </span>
          <span className="overview_header_seprator" aria-label="Separator">|</span>
          <MTooltip title="Close">
            <IconButton
              style={{ padding: 0 }}
              aria-label="Close Monitored Devices"
              onClick={() => {
                this.props.handleCloseDialog("showActiveDevices");
              }}
            >

              <Clear className="clearIcon" role="button"
                title="Close" />
            </IconButton>
          </MTooltip>
        </div>
      </div>
    );
    if (
      this.state.status === "loading" &&
      !this.props.didActiveDevicesInvalidate
    ) {
      view = (
        <div
          className="no_data_panel"
          style={{
            height: `${this.props.homeScreenComponents.showDevicesByRoles ? "43%" : "80%"
              }`,
            fontSize: "0.5rem",
            flex: "90%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress style={{ color: "#3272D9" }} />
        </div>
      );
    } else if (
      this.state.status === "failure" ||
      this.props.didActiveDevicesInvalidate
    ) {
      view = (
        <div
          className="no_data_panel"
          style={{
            height: `${this.props.homeScreenComponents.showDevicesByRoles ? "43%" : "80%"
              }`,
            fontSize: "0.5rem",
            flex: "90%",
          }}
        >
          <Error />
        </div>
      );
    }
    return (
      <Card
        className={this.props.className}
        // style={{
        //   // height: null,
        //   width: null,
        //   margin: null,
        // }}
        style={{
          height: this.props.homeScreenComponents.showDevicesByRoles
            ? "19vh"
            : window.innerHeight < 800
              ? "36vh"
              : window.innerHeight == 800
                ? "38vh"
                : window.innerHeight < 1080
                  ? "39vh"
                  : "40vh",
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          padding: "16px",
          boxSizing: "border-box"
        }}
      >
        {cardHeader}
        {view}
      </Card>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActiveDevicespoll: () => dispatch(fetchActiveDevicespoll()),
    pollActiveDevicesStop: () => dispatch(pollActiveDevicesStop()),
  };
};
const mapStateToProps = (state) => {
  return {
    data: state.homeScreen.activeDevices,
    isFetching: state.homeScreen.isFetching,
    didActiveDevicesInvalidate: state.homeScreen.didActiveDevicesInvalidate,
    homeScreenComponents: state.homeScreen.homeScreenComponents,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PanelContainer); //connect so that we can get a handle on history
